import React, { useState } from 'react';
import { MarketingAPIQueuePushRequest } from '../../../interfaces/marketing';
import { marketingAPI } from '../../../api/marketing';

type Props = {
  className?: string;
};

export const PDFBoldStatement: React.FC<Props> = ({ className }) => {
  const [inputEmail, setInputEmail] = useState('');
  return (
    <>
      <div className={`text-center ${className}`}>
        <h2 className="text-4xl tracking-tight font-bold  sm:text-3xl md:text-5xl">
          <span className="block text-gray-900">PDFs Suck</span>
        </h2>
        <p className="px-0 mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
          PDFs leave your customers with a bad taste in their mouth.
        </p>
        <div className="mx-auto">
          <form
            className="mt-5 sm:flex sm:items-center xl:w-1/3 md:w-1/2 sm:w-3/4 justify-center mx-auto "
            id={'pdf_hero_form'}
            onSubmit={async e => {
              e.preventDefault();
              // @ts-ignore
              window.analytics.identify({
                email: inputEmail,
              });
              const pushToQ: MarketingAPIQueuePushRequest = {
                email: inputEmail,
              };
              const response = await marketingAPI.pushEmailToQueue(pushToQ);
              window.open(
                'https://portal.tabletab.io/signup?ref=pdf_hero_form',
              );
            }}
          >
            <div className="max-w-xs w-full">
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                required
                onChange={e => {
                  setInputEmail(e.target.value);
                }}
                className="shadow-sm focus:ring-gray-900 focus:border-gray-900 block w-full text-base border-gray-300 rounded-full"
                placeholder="Enter your email"
              />
            </div>
            <button
              type="submit"
              className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base shadow-sm font-medium rounded-full text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 sm:mt-0 sm:ml-3 sm:w-2/3 lg:w-2/3 2xl:w-1/2 "
            >
              Get an upgrade
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
